import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService} from '../auth.service';
import { UserService } from '../user.service';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';


@Injectable({ providedIn: 'root'})
export class PublicGuard  {
    constructor(private auth: AuthService, private user: UserService, private router: Router) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.auth.currentUserData$.pipe(
            take(1),
            map(user => !!user),
            tap(loggedIn => {
                if (loggedIn) {
                    this.router.navigate([this.user.getHomepage()]);
                }
            }),
            map(_=> true)
        );
    }
}
